import styled from 'styled-components';
import bgShadow from '../../assets/images/bg_shadow.png';

const StyledContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
`;

const StyledShadow = styled.div`
	position: absolute;
	width: 3600px;
	height: 2100px;
	left: 50%;
	transform: translateX(-50%);
	bottom: -1050px;
	background-image: url(${bgShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export { StyledContainer, StyledShadow };
